import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { Redirect } from 'react-router-dom'
import {
  Container, Spinner, Table, Row, Col, Button,
  Modal, ModalHeader, ModalBody, ModalFooter,
  Card, CardBody, Badge, CardHeader,
  Label, FormGroup, Input,
} from 'reactstrap'
import { Tab, Tabs, TabList, TabPanel } from 'react-tabs'
import { MapContainer, TileLayer, Marker } from 'react-leaflet'
import moment from 'moment'
import MaskedInput from '../../components/Template/Input/MaskedInput'
import DatePicker from 'react-datepicker'
import Select from '../../components/Template/Input/Select'
import { People, PeoplePicker } from '@microsoft/mgt-react'
import { currencyFormatter } from '../../utils/currencyFormatter'
import { getProject, getProjectContract, getProductFiles, getProjectProducts, getTeam, getProjectTeam, getAval, getAprov } from '../../store/ducks/technicalDep'
import StepStatus from '../../components/Template/Progress/StepStatus'
import { notifySuccess, notifyError } from '../../utils/notify'
import powerAppsApi from '../../services/powerapps/index'
import oikosApi from '../../services/oikos'
import { graphClient } from '../../store/sagas/auth'

class Project extends Component {
  constructor(props) {
    super(props)
    this.state = {
      viewProductModalIsOpen: false,
      viewProductData: {},
    }
  }

  componentDidMount() {
    const { getProject, getProjectProducts, getProductFiles, getProjectTeam, getProjectContract, getTeam, getAval, getAprov } = this.props
    const { id } = this.props.match.params

    getProject(id)
    getProjectProducts(id)
    getProductFiles(1040)
    getTeam()
    getProjectTeam(id)
    //getProjectContract(id)
    //this.getDocuments()
    getAval()
    getAprov()
  }

  mapStatusCode = status => {
    switch (status) {
      case 'Elaborando': return 2
      case 'Preparando Entrega': return 2
      case 'Atrasado': return 2
      case 'Correção EP': return 2
      case 'Liberado': return 2
      case 'Aprovação Direção': return 2
      case 'Entregue': return 4
      case 'Enviado para Cliente (Digital)': return 3
      case 'Em Revisão 1': return 4
      case 'Em Revisão 2': return 4
      case 'Em Revisão 3': return 4
      case 'Aprovado pelo Cliente': return 5
      default: return 1
    }
  }

  formatProjectStatus = status => {
    switch (status) {
      case 'Em andamento':
        return <Badge className="badge-soft-info mr-1">{status}</Badge>
      case 'Em conclusão':
        return <Badge className="badge-soft-warning mr-1">{status}</Badge>
      case 'Concluído':
        return <Badge className="badge-soft-success mr-1">{status}</Badge>
      case 'Cancelado':
        return <Badge className="badge-soft-danger mr-1">{status}</Badge>
      case 'Suspenso':
        return <Badge className="badge-soft-danger mr-1">{status}</Badge>
      default:
        return <Badge className="badge-soft mr-1">{status}</Badge>
    }
  }

  render() {

    const {
      project, getProjectIsLoading,
      getProjectProductsIsLoading, projectProducts,
      projectTeam, getProjectTeamIsLoading, productFiles,
    } = this.props.technicalDep

    const {
      getProductFiles,
    } = this.props

    const { viewProductData, viewProductModalIsOpen} = this.state

    console.log('project = ', project)

    if (getProjectIsLoading) {
      return (
        <div className="centered">
          <Spinner />
        </div>
      )
    }

    if (!getProjectIsLoading && !getProjectTeamIsLoading && project) {
      return (
        <>

        <Modal
          centered={false}
          isOpen={viewProductModalIsOpen}
          toggle={() => this.setState({ viewProductData: {}, viewProductModalIsOpen: false })}
        >
          <ModalHeader
            toggle={() => this.setState({
              viewProductData: {},
              viewProductModalIsOpen: false,
            })}
          >
            Anexos do Produto
          </ModalHeader>
          <ModalBody>
            <FormGroup>
              <Label>
                {viewProductData?.prod_desc} - {productFiles[0].arquivo_id}
              </Label>
            </FormGroup>

          </ModalBody>
          <ModalFooter />
        </Modal>

        <div className="page-content">
          <Container fluid>
            <Row className="mt-2">
              <Col>
                <h3 style={{ marginBottom: 0, paddingBottom: 0 }}>
                  {project.proj_nome}
                </h3>
                <Row className="mt-2 flex-grow-1">
                  <Col className="col-md-auto d-flex flex-column">
                    <span style={labelStyle}>
                      Status
                    </span>
                    <span>
                      {this.formatProjectStatus('Em andamento')}
                    </span>
                  </Col>
                  <Col className="col-md-auto d-flex flex-column">
                    <span style={labelStyle}>
                      Cliente
                    </span>
                    <span>
                      {project.pj_nomeFanta}
                    </span>
                  </Col>
                  <Col className="col-md-auto d-flex flex-column">
                    <span style={labelStyle}>
                      Segmento
                    </span>
                    <span>
                      {project.areaAtua_id}
                    </span>
                  </Col>
                  <Col className="col-md-auto d-flex flex-column">
                    <span style={labelStyle}>
                      Equipe
                    </span>
                    <div className="d-flex mt-1">
                      {projectTeam?.length > 0 && (
                        <People
                          showMax={10}
                          peopleQueries={projectTeam.map(person => person.email)} />
                      )}
                    </div>

                  </Col>
                </Row>
              </Col>
            </Row>

            <Row className="mt-3">
              <Col>
                <Tabs>
                  <TabList>
                    <Tab>Visão geral</Tab>
                    <Tab>Produtos</Tab>
                  </TabList>

                  <TabPanel>
                    <Row>
                      <Col>
                        <Card>
                          <CardHeader>
                            Descrição
                          </CardHeader>
                          <CardBody>
                            {project.contrato_obj}
                          </CardBody>
                        </Card>
                      </Col>
                    </Row>

                    <Row>
                      <Col>
                        <Card>
                          <CardHeader>
                            Contrato
                          </CardHeader>
                          <CardBody>
                            <Table responsive bordered>
                              <tr>
                                <th>Número</th>
                                <td>{project.contrato_num}</td>
                              </tr>
                              <tr>
                                <th>Data de assinatura</th>
                                <td>{project.contrato_dtAssin ? moment(project.contrato_dtAssin).format('DD/MM/YYYY') : null}</td>
                              </tr>
                              <tr>
                                <th>Fim da vigência</th>
                                <td>{project.contrato_prazoVigencia ? moment(project.contrato_prazoVigencia).format('DD/MM/YYYY') : null}</td>
                              </tr>
                              <tr>
                                <th>Valor total</th>
                                <td>{currencyFormatter.format(project.contrato_vlrGlobal)}</td>
                              </tr>
                            </Table>
                          </CardBody>
                        </Card>
                      </Col>
                    </Row>

                  </TabPanel>

                  <TabPanel>
                    {getProjectProductsIsLoading && (
                      <Row className="mt-2">
                        <Col className="d-flex justify-content-center">
                          <Spinner size="sm" />
                        </Col>
                      </Row>
                    )}
                    {!getProjectProductsIsLoading && projectProducts && (
                      <>
                        {projectProducts.map(product => (
                          <Row>
                            <Col>
                              <Card order={['prod_dtInterna', 'asc']}>
                                <CardBody>
                                  <Row className="align-items-center">
                                    <Col>
                                      <Row>
                                        <Col xs="auto">
                                          <h5 style={{ fontWeight: '500' }}>
                                            {product.prod_desc}
                                          </h5>
                                        </Col>

                                      </Row>
                                      <Row className="mt-2 align-items-center">
                                        <Col>
                                          <StepStatus actual={this.mapStatusCode(product.temp_status)} />
                                        </Col>
                                      </Row>

                                      <Row>
                                        <Col className="col-md-auto d-flex flex-column">
                                          <span style={labelStyle}>
                                            Responsável
                                          </span>
                                          {product.prod_responsavel && (
                                            <People
                                              className="mt-1"
                                              peopleQueries={[product.prod_responsavel_email]} />
                                          )}
                                        </Col>

                                          {/*
                                        <Col className="col-md-auto d-flex flex-column">
                                          <span style={labelStyle}>
                                            Valor
                                          </span>
                                          <span>
                                            {currencyFormatter.format(product.prod_vlr)}
                                          </span>
                                        </Col>
                                          */}

                                        <Col className="col-md-auto d-flex flex-column">
                                          <span style={labelStyle}>
                                            Data prevista
                                          </span>
                                          <span>
                                            {moment(product.prod_dtInterna).format('DD/MM/YYYY')}
                                          </span>
                                        </Col>

                                        <Col className="col-md-auto d-flex flex-column">
                                          <span style={labelStyle}>
                                            Data contratual
                                          </span>
                                          <span>
                                            {moment(product.prod_dtContrato).format('DD/MM/YYYY')}
                                          </span>
                                        </Col>

                                        <Col className="col-md-auto d-flex flex-column">
                                          <span style={labelStyle}>
                                            Status
                                          </span>
                                          <span>
                                            {product.temp_status}
                                          </span>
                                        </Col>
                                        <Col className="col-md-auto d-flex flex-column">
                                          <span style={labelStyle}>
                                            Arquivos
                                          </span>
                                          <Button
                                            title="Arquivos"
                                            className="ml-2"
                                            color="light"
                                            size="sm"
                                            onClick={() => { this.setState({
                                              viewProductData: product,
                                              viewProductModalIsOpen: true,
                                            })
                                            console.log('viewProductData depois de setstate =', viewProductData)
                                            console.log('product depois de setstate =', product)
                                            getProductFiles(product.prod_id)
                                            console.log('productFiles  =', productFiles)
                                            }}

                                          ><i className="ri-folder-open-fill" /></Button>
                                        </Col>
                                      </Row>
                                    </Col>
                                  </Row>
                                </CardBody>
                              </Card>
                            </Col>
                          </Row>
                        ))}
                      </>
                    )}
                  </TabPanel>
                </Tabs>
              </Col>
            </Row>
          </Container>
          </div>
          <>
          </>
        </>
      )
    }

    return null
  }
}

const labelStyle = {
  fontSize: '0.75rem',
  color: '#adb5bd',
  lineHeight: '1.5',
  marginTop: 16,
}

const mapStateToProps = state => ({
  auth: state.auth,
  technicalDep: state.technicalDep,
})
const mapDispatchToProps = dispatch => bindActionCreators({
  getProject,
  getProjectProducts,
  getProductFiles,
  getTeam,
  getProjectTeam,
  getProjectContract,
  getAval,
  getAprov,
}, dispatch)
export default connect(mapStateToProps, mapDispatchToProps)(Project)
